const toastErrors = {
  'not-found': 'Dokumen biaya tidak ditemukan',
  'failed-to-get': 'Gagal mengambil data dokumen biaya',
  'failed-to-save': 'Gagal menyimpan data dokumen biaya',
  'invalid/invalid-fields': 'Gagal ubah status. Mohon periksa kembali data Anda.',
  'invalid-input-format': 'Terdapat kesalahan format pada input anda.',
}

export default toastErrors
